import { Compass } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '../components/Button'
import { EmptyState } from '../components/EmptyState'

export default function NotFound() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <EmptyState
        icon={Compass}
        title="Page not found"
        description="Nothing lives at this address. It may have moved, or the link was mistyped."
        action={
          <Link to="/today">
            <Button>Back to Today</Button>
          </Link>
        }
      />
    </div>
  )
}
